<template>
  <nav>
    <ul class="nav nav-pills flex-column">
      <slot></slot>
    </ul>
  </nav>
</template>
